// Opciones compartidas para el formulario público y el CRM de prospectos.

export const ROOM_INTEREST_OPTIONS = [
  "Habitación 1",
  "Habitación 3",
  "Habitación 5",
  "Habitación 6",
  "Habitación 7",
  "Habitación 8",
  "Habitación 9",
  "Habitación 10",
  "Habitación 11",
  "Habitación 12",
  "Habitación 13",
  "Habitación 14",
  "Habitación 15",
  "Habitación 16",
  "Habitación 17",
  "Habitación 18",
  "Habitación 19",
  "Habitación 20",
  "No estoy seguro",
];

export const BUDGET_OPTIONS = [
  "Menos de $4,000",
  "$4,000 - $5,000",
  "$5,000 - $6,000",
  "$6,000 - $7,000",
  "Más de $7,000",
];

export const PEOPLE_OPTIONS = [
  "1 adulto",
  "2 adultos",
  "1 adulto + 1 niño",
];
